import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

import type { SalesAnalyticsDispatcher } from "../sales-context/SalesContext.types";

export type SendNotificationPayload = {
    sessionId: string;
    partner: string;
    productOfferId: string;
    productSku: string;
    customerEmailId?: string;
    customerMdn?: string;
    customerChatId?: string;
    workerSid?: string;
    topic?: string;
    language?: string;
};

export type SendNotificationResponse = {
    maxAttemptsReached: boolean;
    currentAttempt: number;
};

export async function sendNotification(
    client: KyInstance,
    logger: Logger,
    dispatcher: SalesAnalyticsDispatcher,
    payload: SendNotificationPayload,
): Promise<SendNotificationResponse> {
    if (!payload.customerEmailId && !payload.customerMdn) {
        throw new Error("Either customerEmailId or customerMdn must be provided");
    }
    const childLogger = logger.child({ module: "sendNotification" });

    childLogger.info({ payload }, "Sending notification");

    try {
        const response = await client.post("v1/send-notification", { json: payload });
        if (!response.ok) {
            throw new Error(`Failed to send notification: ${response.status} ${response.statusText}`);
        }
        const data = await response.json<SendNotificationResponse>();
        if (data === null) {
            throw new Error("Received null response from notification service");
        }
        void dispatcher.dispatchBusinessEvent("NotificationSent");
        return data;
    } catch (error) {
        void dispatcher.dispatchBusinessEvent("NotificationSendFailure");
        childLogger.warn({ error }, "Error sending notification");
        throw error;
    }
}
